import { Switch } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { LinkSharp } from "@material-ui/icons";
import Search from "@material-ui/icons/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { useDebounce } from "hooks/useDebounce";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { collectionService } from "services/collectionService";
import { nftService } from "services/nftService";
import { getIpfsUrl } from "../../helper/ipfsHelper";
import NftView from "./NftView";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import { nftSaleService } from "services/nftSaleService";
import { toast } from "react-toastify";
import { getEllipsisTxt } from "helper/fommaters";
import Select from "components/Select/Select";
import { chainOptions } from "const";

const FE_LINK = process.env.REACT_APP_FE_LINK;

export default function NftIndex() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [viewId, setViewId] = useState("");
  const [page, setPage] = useState(0);
  const [page2, setPage2] = useState(0);
  const [size] = useState(10);
  const [count, setCount] = useState(0);
  const [options, setOptions] = useState([]);
  const [collectionName, setCollectionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const keywordCollect = useDebounce(collectionName, 500);
  const keywordName = useDebounce(search.trim(), 500, () => {
    setPage2(0);
  });
  const [chainId, setChainId] = React.useState("-1");
  const [tokenAddress, setTokenAddress] = useState("");

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = useMemo(
    () => [
      {
        Header: "Thumbnail",
        accessor: "image",
        Cell: Thumnail,
      },
      {
        Header: "TokenID",
        accessor: "tokenId",
      },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Price",
        accessor: "unitPrice",
      },
      {
        Header: "Seller",
        Cell: function seller({ cell }) {
          const sellerAddress = cell.row.original.sellerAddress?.toLowerCase();
          return (
            <span
              onClick={() => {
                navigator.clipboard.writeText(sellerAddress);
                toast.success("Copied to clipboard");
              }}
            >
              {getEllipsisTxt(sellerAddress)}
            </span>
          );
        },
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return <Action cell={cell} setItems={setItems} />;
        },
      },
    ],
    [items]
  );

  async function fetchNfts() {
    const payload = {
      tokenAddress: tokenAddress,
      search: keywordName.trim() ? keywordName.trim() : "",
      page: page2,
      size,
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;

    try {
      setIsLoading(true);
      const { data } = await nftService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  }

  // function updateItems(data, index) {
  //     if (data) {
  //         const newItems = [...items];
  //         newItems.splice(index, 1, {
  //             ...items[index],
  //             name: data.name,
  //             image: data.image,
  //             description: data.description,
  //         });
  //         setItems(newItems);
  //     }
  // }

  const setPageAll = (page) => {
    setPage(page);
    setPage2(page);
  };

  useEffect(() => {
    fetchNfts();
  }, [page, keywordName, tokenAddress, chainId]);

  useEffect(() => {
    const getCollections = async () => {
      const { data } = await collectionService.list({
        search: keywordCollect.trim() ? keywordCollect.trim() : null,
        page: 0,
        size: 15,
      });
      setOptions(
        data.items.map((item) => ({ value: item?.address, label: item?.name }))
      );
    };
    getCollections();
  }, [keywordCollect]);

  return (
    <div>
      <NftView id={viewId} onClose={() => setViewId("")} />

      {confirm}
      {/* <Link to="/admin/nft/create">
        <Button color="info">Create new nft</Button>
      </Link> */}

      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText="Search"
            id="search"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <Select
            label={"Chain"}
            value={chainId}
            onChange={setChainId}
            options={[{ value: "-1", label: "All" }, ...chainOptions()]}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={6}>
          <Autocomplete
            options={options}
            onChange={(e, value) => {
              setPage2(0);
              setTokenAddress(value?.value || "");
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                value={collectionName}
                onChange={(e) => {
                  setCollectionName(e.target.value);
                }}
              />
            )}
          />
        </GridItem>
      </GridContainer>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPageAll}
        size={size}
        columns={columns}
        data={items}
        isLoading={isLoading}
      />
    </div>
  );
}

function Active({ cell }) {
  return (
    <Switch
      checked={cell.value}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

Active.propTypes = {
  cell: PropTypes.any,
};

function Action({ cell, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleClickOpen = () => {
    setOpenDialogDel(true);
  };

  const handleClose = () => {
    setOpenDialogDel(false);
  };

  const deleteNft = async (id) => {
    await nftSaleService.remove(id);
    setItems((prev) => prev.filter((x) => x._id !== id));
    handleClose();
  };

  return (
    <div
      className="actions-right"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <a
        href={`${FE_LINK}/detail/${cell.row.original.tokenAddress}/${cell.row.original.tokenId}`}
        target="_blank"
        rel="noreferrer"
      >
        <Button justIcon round simple color="success" className="edit">
          <LinkSharp />
        </Button>
      </a>

      <div>
        <DeleteIcon
          onClick={() => handleClickOpen()}
          style={{ fontSize: "20px", color: "#ce2727", cursor: "pointer" }}
        />

        <Dialog
          open={openDialogDel}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Delete NFT"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="transparent">
              Cancel
            </Button>
            <Button
              onClick={() => deleteNft(cell.row.original._id)}
              color="success"
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  setItems: PropTypes.any,
};

function Thumnail({ cell }) {
  const type = cell.row.original.fileType;
  const value = cell.value;
  switch (type) {
    case "video":
      return <video width="100%" controls src={value}></video>;
    case "audio":
      return (
        <audio style={{ width: "100%" }} controls muted>
          <source src={value} />
        </audio>
      );
    default:
      return (
        <img
          src={getIpfsUrl(value)}
          className="lazy nft__item_preview"
          height="50px"
        />
      );
  }
}

Thumnail.propTypes = {
  cell: PropTypes.any,
};

function Type({ cell }) {
  const type = cell.value;
  switch (type) {
    case "video":
      return "Video";
    case "audio":
      return "Audio";
    default:
      return "Image";
  }
}
Type.propTypes = {
  cell: PropTypes.any,
};
